export default function AssessmentsDirective() {
  return {
    template: require('./assessments.html'),
    scope: {
      incompleteAssessments: '=',
      hasIncompleteAssessments: '=',
      completedAssessments: '=',
      hasCompletedAssessments: '=',
      rmmReportingSource: '=',
      isNavantaUser: '=',
    },
    controller: 'AssessmentsController',
    controllerAs: 'assessmentsVM',
    bindToController: true,
    replace: true,
  };
}
